// generated from 74 samples

import { z } from "zod";

export const catalogPriceDropTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CatalogPriceDrop"),
  // null: 8 (10.81%)
  catalog_name: z.string().nullable(),
  subscription_type: z.null(),
});
